import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import Header from "~/Header";
import SupportChat from "~/components/SupportChat";

function ProtectedRoute({ children }) {
  const { signed, profile } = useSelector((state) => state.auth);
  if (!signed) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="h-screen flex flex-col justify-start items-start ">
      <Header />
      {/* {profile.force_password_change && <div className='fixed top-0 bg-slate-900/50 left-0 z-50 w-full h-full flex flex-row justify-center items-center'>
        <Form onSubmit={handleUpdatePassword} className='bg-white rounded-md p-4'>

          <InputContext.Provider value={{ setSuccessfullyUpdated }}>
            <InputLineGroup title='GENERAL' activeMenu={true}>
              <InputLine title='Please update your password'>
                <Input type='password' name='password' required title='Password' InputContext={InputContext} />
                <Input type='password' name='confirmPassword' required title='Confirm Password' InputContext={InputContext} />
                <button type='submit' className='text-sm rounded-md border p-2 bg-zinc-100'>Update</button>
              </InputLine>
            </InputLineGroup>
          </InputContext.Provider>
        </Form>
      </div>} */}
      {children}
      {profile?.id === 1 && <SupportChat />}
    </div>
  );
}

export default ProtectedRoute;
